<script setup lang="ts">
/**
 * GoalCard — exibe goal ativo. Sem contador de progresso (CC-01).
 * Copy neutra; Companion ≠ LLM.
 */
import type { Goal } from "../types";

interface Props {
  goal: Goal;
}

defineProps<Props>();
</script>

<template>
  <article class="hlos-goal-card" data-testid="goal-card">
    <h3>{{ goal.title }}</h3>
    <p>{{ goal.description }}</p>
    <footer>
      <small>Iniciado em {{ goal.startedAt }}</small>
    </footer>
  </article>
</template>

<style scoped>
.hlos-goal-card {
  padding: 1rem;
  border: 1px solid color-mix(in srgb, currentColor 20%, transparent);
  border-radius: 0.5rem;
}
h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
}
p {
  margin: 0 0 0.5rem 0;
  opacity: 0.85;
}
footer {
  opacity: 0.6;
}
</style>
